/**
 * @file 工具函数 辅助方法
 */

import * as constants from '@/tools/constants.js';

import * as tools from '@/tools/tools.js';


/*
    检测域名是否合法
        输入 www.baidu.com 返回 https://www.baidu.com
        输入 https://www.baidu.com 返回 https://www.baidu.com
        输入 http://www.baidu.com 返回 http://www.baidu.com
        输入 空格 返回 false
        输入 abcd 返回 false

    验证域名规则
        有http的直接使用, 没有http的拼接https://
*/

export function checkHostFn(host) {
	host = host.trim();
	if (host) {
		let protocolReg = /^https?:\/\//gim; // 协议头正则

		let domainReg = /^[A-z0-9\-]+\.([A-z0-9\-]*\.){0,}[A-z0-9\-]+$/gim; // 域名正则

		let protocol = 'https://'; // 默认的协议头
		if (protocolReg.test(host)) {
			protocol = host.match(protocolReg)[0];
		}

		host = host.replace(protocol, '').replace(/\//gim, '');

		let isDomain = host.match(domainReg);
		if (isDomain) {
			return `${protocol}${host}`;
		}
		return false;
	}
	return false;
}






/**
 * @description 判断 图片路径 是否http或https开头 如果是 直接返回path 否则返回拼接host的路径
 * @param {string} host 域名
 * @param {string} path 图片路径
 * @return {string} 返回的是完整图片路径
 *
 */
export function makeImageUrlFn(host, path) {
	host = tools.assertString(host);
	path = tools.assertString(path);

	if (path.startsWith('http://') || path.startsWith('https://')) {
		return path;
	}
	return `${host}${path}`;
}




/**
 * @description localStorage 跨页面通信工具函数
 */
export function storagePostMsgFn() {
	const key = 'emit:storageChange';
	return {
		sendFn(data) {
			localStorage.setItem(
				key,
				JSON.stringify({
					random: Math.random(),
					data,
				})
			);
		},
		parseFn(e) {
			if (e.key === key) {
				const {
					data
				} = JSON.parse(e.newValue);
				return data;
			}
			return false
		}
	}
}







/**
 * @description 播报语音
 */
export function textToAudioPlayFn(text) {
	if (window.ttsspeaker) {
		window.ttsspeaker(text);
	} else {
		const play = window.speechSynthesis;
		play.cancel();
		play.speak(new SpeechSynthesisUtterance(text))
	}
}





/**
 * @description 获取称数据
 */
export function getScaleDatasFn() {
	const data = window.getScale();

	// console.log('window.getScale=>data', data);
	/*
	data==> {"state":2,"weight":"00.000"}
	data==> {"state":1,"weight":"00.014"}
	data==> {"state":2,"weight":"00.012"}
	data==> {"state":1,"weight":"00.006"}
	data==> {"state":2,"weight":"00.000"}
	data==> {"state":1,"weight":"00.062"}
	data==> {"state":2,"weight":"00.030"}
	data==> {"state":1,"weight":"00.000"}
	data==> {"state":2,"weight":"00.000"}
	data==> {"state":1,"weight":"00.012"}
	data==> {"state":2,"weight":"00.012"}
	data==> {"state":2,"weight":"00.000"}
	*/
	/*
		weight 重量
		state 称状态
			0: 未连接
			1: 不稳定
			2: 稳定
	*/

	let json = {
		state: 0,
		weight: 0
	};

	try {
		json = JSON.parse(data);
	} catch (e) {
		console.log('JSON.parse data catch e ', e);
	}

	return {
		scaleNumber: (() => {
			const num = Number(json.weight);
			return num >= 0 ? num : 0;
		})(),
		scaleStatus: (() => {

			if (json.state == 1) {
				return constants.scaleStateEnum.unStable;
			}
			if (json.state == 2) {
				return constants.scaleStateEnum.stable;
			}
			return constants.scaleStateEnum.notConnected;
		})()
	}
}




// 处理商品数据结构
export const formatGoodsDataFunc = (i, that) => {

	return {
		goodsId: tools.transNumFn(i.goods_id),
		goodsImage: i.original_img,
		goodsName: i.goods_name,
		price: tools.objectGetDoubleNum(i, 'desk_price'),
		unitText: tools.assertString(i.showUnitText),
		// 是否库存不足
		outofstock: i.have_store_count === 0,

		...(() => {

			// 商品是称重商品时, 分拣重量 与 分拣单位(克、斤、公斤)
			const weightDatas = {};


			// 保存重量数据
			const setWeightDataFn = (num, unit) => {
				weightDatas.sortingWeightNumber = num;
				if (unit === 1) {
					weightDatas.sortingWeightUnit = constants.unitType.ke;
				} else if (unit === 2) {
					weightDatas.sortingWeightUnit = constants.unitType.kg;
				} else if (unit === 3) {
					weightDatas.sortingWeightUnit = constants.unitType.jin;
				}
			}

			const goodsIsWeigh = (() => {

				if ([1, 2, 3].includes(i.weight_type)) {
					// 第一个单位选的是重量单位 1：g（克） 2：kg（千克）3：斤
					setWeightDataFn(tools.objectGetDoubleNum(i, 'weight'), i
						.weight_type);
					return true;
				} else if ([0].includes(i.weight_type)) {
					// 0:第一个单位选的不是重量单位


					if (i.fenjian_weight_type === 3) {
						// 分拣按净含量单位
						setWeightDataFn(tools.objectGetDoubleNum(i, 'jing_weight'),
							i.jing_weight_type);
						return true;
					} else if (i.fenjian_weight_type === 2 && [1, 2, 3].includes(i
							.danwei_weight_type)) {
						// 分拣按转换单位 && 转换单位是称重单位
						setWeightDataFn(tools.objectGetDoubleNum(i,
							'danwei_weight'), i.danwei_weight_type);
						return true;
					}
				}
				return false;
			})();


			return {
				...weightDatas,
				measuringType: goodsIsWeigh ? constants.goodsMeasuringMethod.chengzhong : constants
					.goodsMeasuringMethod.biaopin,
			}
		})(),




	}


}




/**
 * @description 限制输入值为合法的 保留两位小数 的数字
 * @param {string | number} val 输入值
 * @return {string} 返回的是 合法的 保留两位小数 的数字
 */
export function checkDoubleNumFn(val) {
	val = val
		.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
		.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
		.replace(/^\./g, '') // 保证第一个为数字而不是.
		.replace('.', '$#$')
		.replace(/\./g, '')
		.replace('$#$', '.')

	if (val.indexOf('.') < 0 && val !== '') {
		// 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
		val = parseFloat(val) + ''
	} else if (val.indexOf('.') >= 0) {
		val = val.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')
		// 只能输入两个小数
	}
	return val;
}




/**
 * @description 限制输入值为合法的 保留3位小数 的数字字符串
 * @param {string | number} val 输入值
 * @return {string} 返回的是 合法的 保留3位小数 的数字字符串
 */
export function checkThreeNumFn(val) {
	// 只保留数字和小数点
	const value = `${val}`.replace(/[^\d.]/g, '');

	// 空串 与 单个点时返回空
	if (['', '.'].includes(value)) return '';

	// 限制小数位数为三位
	if (value.includes('.')) {
		const [n1, n2] = value.split('.');
		return `${n1}.${n2.substring(0, 3)}`;
	}
	return `${Number(value)}`;
}



/**
 * @description 限制输入值为合法的 整数
 * @param {string | number} val 输入值
 * @return {string} 返回的是 合法的 整数 数字字符串
 */
export function checkIntNumFn(val) {
	const value = `${val}`.replace(/[^\d]/g, '');
	return value === '' ? '' : `${Number(value)}`;
}



/**
 * @deprecated 传入时间戳(秒级)返回时间字符串 不传为当前时间
 * @example 1658798820 -> '2022-07-26'
 */
export function getDateFn(time) {
	// 获取当前日期
	let date = new Date();
	if (time) {
		date = new Date(Number(time) * 1000);
	}

	// 获取年
	let year = date.getFullYear();

	// 获取当前月份
	let nowMonth = date.getMonth() + 1;
	nowMonth = `0${nowMonth}`.slice(-2);

	// 获取当前是几号
	let strDate = date.getDate();
	strDate = `0${strDate}`.slice(-2);

	return `${year}.${nowMonth}.${strDate}`;
}







/**
 * @deprecated 传入时间戳(秒级)返回时间字符串
 * @example 1658798820 -> '2022-07-26 09:27:00'
 */
export function getTimeFn(time) {
	let timeStamp = tools.transNumFn(time) * 1000;

	// 获取当前日期
	var date = new Date(timeStamp);

	// 获取年
	var year = date.getFullYear();

	// 获取当前月份
	var nowMonth = date.getMonth() + 1;
	nowMonth = `0${nowMonth}`.slice(-2);

	// 获取当前是几号
	var strDate = date.getDate();
	strDate = `0${strDate}`.slice(-2);

	// 小时
	var hours = date.getHours();
	hours = `0${hours}`.slice(-2);

	// 分钟
	var minutes = date.getMinutes();
	minutes = `0${minutes}`.slice(-2);

	// 秒
	var seconds = date.getSeconds();
	seconds = `0${seconds}`.slice(-2);

	return `${year}-${nowMonth}-${strDate} ${hours}:${minutes}:${seconds}`;
}






// 键盘设置操作
export const handleKeyboardSetFn = () => {
	const key = 'keyboardSetKey';
	return {
		getFn: () => tools.assertString(localStorage.getItem(key)),
		setFn: state => localStorage.setItem(key, state)
	}
}




// ai识别开启/关闭设置操作
export const handleAirecogSetFn = () => {
	const key = 'airecogSetKey';
	return {
		getFn: () => tools.assertString(localStorage.getItem(key)),
		setFn: state => localStorage.setItem(key, state)
	}
}






// 返回合法base64图片路径
export const base64ImagePathFn = base64Data => `data:image/jpeg;base64,${base64Data}`;



// 操作权限数据
export const handlePermissionFn = () => {
	const key = 'permissionKey';
	return {
		getFn: () => {
			const str = tools.assertString(localStorage.getItem(key));
			return str ? JSON.parse(str) : [];
		},
		setFn: list => localStorage.setItem(key, JSON.stringify(list))
	}
}


// 检测权限
export const checkPermissionFn = (that, permissionId) => {
	const list = handlePermissionFn().getFn(),
		flag = list.includes(permissionId);

	setTimeout(() => {
		if (!flag) {
			let toPath = '/';
			if (list.length) {
				const {
					path
				} = constants.menuList.filter(i => list.includes(i.permissionId))[0];
				toPath = `/nav/${path}`;
			}
			that.$router.replace({
				path: toPath
			});
		}
	});

	return flag;
};





/**
 * @description 16进制色值转rgba
 */
export const hex2RgbaFn = (hex, opacity) => {
	const r = parseInt(`0x${hex.slice(1, 3)}`),
		g = parseInt(`0x${hex.slice(3, 5)}`),
		b = parseInt(`0x${hex.slice(5, 7)}`),
		a = opacity;
	return `rgba(${r}, ${g}, ${b}, ${a})`;
}


// WEBPACK FOOTER //
// ./src/tools/utils.js